import React, { useState, useEffect, useRef } from 'react';
import { FaPlay, FaPause, FaVolumeUp, FaVolumeOff } from 'react-icons/fa';
import './MusicPlayer.css';

const MusicPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [volume, setVolume] = useState(0.3);
  const audioRef = useRef(null);

  // 使用本地音乐文件
  const musicUrl = '/alwaysonline.mp3';

  useEffect(() => {
    // 创建音频元素并自动播放
    if (audioRef.current) {
      audioRef.current.volume = volume;
      audioRef.current.loop = true;
      
      // 尝试自动播放
      const playAudio = async () => {
        try {
          await audioRef.current.play();
          setIsPlaying(true);
        } catch (e) {
          console.log('自动播放失败，用户需要手动开启:', e);
        }
      };
      
      // 延迟一点时间再播放，确保组件已完全加载
      const timer = setTimeout(playAudio, 1000);
      return () => clearTimeout(timer);
    }
  }, [volume]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume;
    }
  }, [volume]);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play().catch(e => {
          console.log('音频播放失败:', e);
        });
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (audioRef.current) {
      audioRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
  };

  return (
    <div className="music-player">
      <audio
        ref={audioRef}
        src={musicUrl}
        onEnded={() => setIsPlaying(false)}
        onError={(e) => console.log('音频加载错误:', e)}
      />
      
      <div className="music-controls">
        <button className="control-btn" onClick={togglePlay}>
          {isPlaying ? <FaPause /> : <FaPlay />}
        </button>
        
        <div className="volume-control">
          <button className="control-btn" onClick={toggleMute}>
            {isMuted ? <FaVolumeOff /> : <FaVolumeUp />}
          </button>
          <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={volume}
            onChange={handleVolumeChange}
            className="volume-slider"
          />
        </div>
      </div>
      
      <div className="music-info">
        <span className="music-title">💕 Always Online</span>
      </div>
    </div>
  );
};

export default MusicPlayer;


